<script>

	import Page from '@/containers/Page/Page'

	import Hero from '@/components/Hero/Hero'
	import Companies from '@/components/Companies/Companies'
	import Testimonials from '@/components/Testimonials/Testimonials'
	import About from '@/components/About/About'

	export default {
		name: 'lander',
		components: {
			Page,

			Hero,
			Companies,
			Testimonials,
			About,
		}
	}

</script>

<template>
	<Page class='lander'>
		<Hero />
		<Companies />
		<Testimonials />
		<About />
	</Page>
</template>



// WEBPACK FOOTER //
// src/flows/Lander/Lander.vue